var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/card-tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M33 11.6551V13.5001H3V11.3101C3 7.8751 5.79 5.1001 9.225 5.1001H24V8.9551C24 10.8601 25.14 12.0001 27.045 12.0001H31.455C32.055 12.0001 32.565 11.8951 33 11.6551Z",
    fill: "#F39321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3 13.5V24.69C3 28.125 5.79 30.9 9.225 30.9H26.775C30.21 30.9 33 28.125 33 24.69V13.5H3ZM12 25.875H9C8.385 25.875 7.875 25.365 7.875 24.75C7.875 24.135 8.385 23.625 9 23.625H12C12.615 23.625 13.125 24.135 13.125 24.75C13.125 25.365 12.615 25.875 12 25.875ZM21.75 25.875H15.75C15.135 25.875 14.625 25.365 14.625 24.75C14.625 24.135 15.135 23.625 15.75 23.625H21.75C22.365 23.625 22.875 24.135 22.875 24.75C22.875 25.365 22.365 25.875 21.75 25.875Z",
    fill: "#F39321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.455 1.5H27.045C25.14 1.5 24 2.64 24 4.545V8.955C24 10.86 25.14 12 27.045 12H31.455C33.36 12 34.5 10.86 34.5 8.955V4.545C34.5 2.64 33.36 1.5 31.455 1.5ZM32.445 5.175L28.89 9.33C28.755 9.495 28.545 9.6 28.335 9.6C28.32 9.6 28.32 9.6 28.305 9.6C28.095 9.6 27.9 9.525 27.75 9.375L26.1 7.755C25.8 7.455 25.8 6.96 26.1 6.66C26.4 6.36 26.895 6.345 27.195 6.66L28.245 7.695L31.245 4.185C31.53 3.855 32.01 3.825 32.34 4.095C32.685 4.365 32.715 4.86 32.445 5.175Z",
    fill: "#F39321"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTick);
export default __webpack_public_path__ + "static/media/card-tick.5800d78442ed3566d5c49f79192b6d1b.svg";
export { ForwardRef as ReactComponent };